<template>
  <div class="switcher">
    <div v-for="locale in locales" v-bind:key="locale.key"
    v-on:click="setLocale(locale)">
      <img class="flag" v-bind:class="{ active: locale.key == $i18n.locale }"
      :src="getFlagPath(locale)" :alt="getAltText(locale)">
    </div>
  </div>
</template>

<i18n>
en:
  select: "Switch language to {name}"
de:
  select: "Sprache zu {name} wechseln"
</i18n>

<script>
export default {
  name: 'LanguageSwitcher',
  props: [
    'locales',
  ],
  data() {
    return {

    };
  },
  methods: {
    setLocale: function setLocale(locale) {
      this.$root.$i18n.locale = locale.key;
      localStorage.locale = locale.key;
    },
    getFlagPath: function getFlagPath(locale) {
      return `/static/flags/${locale.key}.svg`;
    },
    getAltText: function getAltText(locale) {
      return this.$t('select', { name: locale.name });
    },
  },
};

</script>

<style lang="scss" scoped>
.switcher {
  display: flex;
  flex-direction: row;
  padding-top: 8px;
  padding-bottom: 8px;
}

$flag-size: 20px;

img.flag {
  width: $flag-size;
  height: $flag-size;
  border-radius: $flag-size / 2;
  object-fit: cover;
  margin-right: 5px;
  cursor: pointer;
  border: #aaa 1px solid;
  filter: brightness(75%);
}

img.flag.active {
  filter: brightness(100%);
}
</style>



// WEBPACK FOOTER //
// src/components/LanguageSwitcher.vue